export const GAMES = {
  "pet-rescue": {
    key: "pet-rescue",
    name: "Pet Rescue Saga",
    path: "/pet-rescue-saga",
    levelRe: /^Pet Rescue Saga level\s*(\d+)(?!\d)/i,
  },
  "harry-potter": {
    key: "harry-potter",
    name: "Harry Potter: Puzzles & Spells",
    path: "/harry-potter-puzzles-spells",
    levelRe: /^Harry Potter: Puzzles & Spells level\s*(\d+)(?!\d)/i,
  },
};

export const blockStart = (level) => Math.floor((level - 1) / 100) * 100 + 1;
